import { FC, useEffect } from "react";

import { SecondaryOverlay } from "components/constants";
import { RECENT_MESSAGE_HOURS } from "components/materials/section/ClassChatSidebarPanel";
import { t } from "i18n/i18n";
import { ButtonBadge } from "mds/components/ButtonBadge";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { ChatWithLinesFilledIcon, ChatWithLinesIcon } from "mds/icons";
import { storeApi, useAppSelector } from "store/index";
import {
  selectCurrentSectionId,
  selectUnreadChatMessageCountForCurrentSection,
} from "store/selectors";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const ChatPanelToggleButton: FC<{ isMobile?: boolean; isMenuItem?: boolean }> = ({
  isMobile = false,
  isMenuItem = false,
}) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.ClassChat);
  const unreadChatMessageCount = useAppSelector(selectUnreadChatMessageCountForCurrentSection);
  const sectionId = useAppSelector(selectCurrentSectionId);

  useEffect(() => {
    if (sectionId) {
      storeApi.chat_messages.list({
        section_id: sectionId,
        created_at__within: `${RECENT_MESSAGE_HOURS}h`,
      });
    }
  }, [sectionId]);

  const icon = unreadChatMessageCount ? <ChatWithLinesFilledIcon /> : <ChatWithLinesIcon />;

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="Class Chat - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText iconStart={icon} text={t("content_sidebar.title.ClassChat")} />
      </MenuItem>
    );
  }

  return (
    <SquareIconButton
      aria-label={t("content_sidebar.title.ClassChat")}
      className="relative"
      eventName="Class Chat - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="secondary"
      size={isMobile ? "xl" : "l"}
      onClick={togglePanel}
    >
      {icon}
      {Boolean(unreadChatMessageCount) && <ButtonBadge>{unreadChatMessageCount}</ButtonBadge>}
    </SquareIconButton>
  );
};
